export const getUrlDocumentoContrato = (productosCuenta, codigoProducto) => {
  if (productosCuenta && productosCuenta.length > 0) {
    return productosCuenta.find((c) => codigoProducto === c.producto)
      .urlDocumentoContrato;
  }
};

export const getUrlDocumentoCartilla = (productosCuenta, codigoProducto) => {
  if (productosCuenta && productosCuenta.length > 0) {
    return productosCuenta.find((c) => codigoProducto === c.producto)
      .urlDocumentoCartilla;
  }
};

export const getUrlDocumentoContratoDpf = (
  productosCuenta,
  codigoMoneda,
  flagTipoPersona
) => {
  if (codigoMoneda && productosCuenta && productosCuenta.length > 0) {
    return productosCuenta.find(
      (c) =>
        codigoMoneda === c.codigoMoneda && flagTipoPersona === c.tipoPersona
    ).urlDocumentoContrato;
  }
};

export const getUrlDocumentoCartillaDpf = (
  productosCuenta,
  codigoMoneda,
  flagTipoPersona
) => {
  if (productosCuenta && productosCuenta.length > 0) {
    return productosCuenta.find(
      (c) =>
        codigoMoneda === c.codigoMoneda && flagTipoPersona === c.tipoPersona
    ).urlDocumentoCartilla;
  }
};
